import { Stage, StepStructure } from 'common/components';

export const FLOOR_SCREED_PATH = '/uslugi/gotovye-resheniya-pod-klyuch/polusuhaya-styazhka-pola/';

export const FLOOR_SCREED_LANDING_NAME = 'floor-screed';

export const FLOOR_SCREED_SERVICE_ID = '1529';

export const FLOOR_SCREED_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/floor-screed-mf';

export const FLOOR_SCREED_HEADER_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/floor-screed-mf';

export const FLOOR_SCREED_ELEMENT_BLOCK = 'landingStyazhka';

export const FLOOR_SCREED_STEPS_LIST: StepStructure[] = [
  {
    title: 'Запишитесь на\u00A0консультацию',
    description:
      'Мы\u00A0перезвоним, бесплатно проконсультируем и\u00A0договоримся о\u00A0выезде специалиста для замера.',
  },
  {
    title: 'Обсудите план работ',
    description:
      'Наш мастер приедет на\u00A0объект, определит объём работ и\u00A0составит смету. Вы\u00A0договоритесь о\u00A0дате и\u00A0времени работ. Цена будет зафиксирована и\u00A0не\u00A0вырастет в\u00A0процессе.',
  },
  {
    title: 'Мы выполним работы',
    description:
      'Мы\u00A0выполним работы в\u00A0срок, указанный в\u00A0договоре. Последним этапом станет сушка поверхности. Соблюдаем технологию работ по\u00A0ГОСТу (Р\u00A052059‑2003).',
  },
  {
    title: 'Примите готовую работу',
    description:
      'Наш специалист проведёт внутренний контроль качества. Вы\u00A0примете готовую работу и\u00A0получите 2\u00A0года гарантии по\u00A0Сервисной карте (без карты\u00A0\u2014 1\u00A0год).',
  },
];

export const FLOOR_SCREED_STAGES_LIST: Stage[] = [
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/stages/1.jpg/1.jpg`,
    imageAlt: 'Этап подготовки основания',
    name: 'Подготовка основания',
    text:
      'Основание очищается, на\u00A0него укладывается гидроизоляционная плёнка, а\u00A0также демпферная лента для компенсации расширения стяжки.',
  },
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/stages/2.jpg/2.jpg`,
    imageAlt: 'Этап установки маяков',
    name: 'Установка маяков',
    text:
      'Для соблюдения правильной геометрии и\u00A0перепада до\u00A03\u00A0мм маяки устанавливаются по\u00A0лазерному уровню.',
  },
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/stages/3.jpg/3.jpg`,
    imageAlt: 'Этап нанесения раствора',
    name: 'Нанесение раствора',
    text:
      'Автоматическая подача готового раствора сокращает время работ. При такой подаче материала не\u00A0нужно занимать лифт, а\u00A0дома не\u00A0будет пыльно.',
  },
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/stages/4.jpg/4.jpg`,
    imageAlt: 'Этап выравнивания',
    name: 'Выравнивание по\u00A0маякам',
    text: 'Свежая стяжка выравнивается по\u00A0всей площади относительно маяков.',
  },
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/stages/5.jpg/5.jpg`,
    imageAlt: 'Этап шлифовки',
    name: 'Шлифовка',
    text: 'Поверхность окончательно выравнивается и\u00A0шлифуется специальным оборудованием.',
  },
  {
    imageSrc: `${FLOOR_SCREED_CDN_PATH}/stages/6.jpg/6.jpg`,
    imageAlt: 'Этап сушки',
    name: 'Сушка и\u00A0набор прочности',
    text: 'Для равномерного высыхания необходимо соблюдать температурный режим и\u00A0избегать сквозняков.',
  },
];
